import React from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES, setLanguage } from "./i18n";

/** Հայ · Eng · Рус — switches the whole site; the choice is remembered in this browser. */
function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  return (
    <div className="lang-switch" role="group" aria-label={t("landing.language")}>
      {LANGUAGES.map((l) => (
        <button
          key={l.code}
          type="button"
          lang={l.code}
          className="lang-switch__option"
          aria-pressed={i18n.resolvedLanguage === l.code}
          aria-label={l.name}
          title={l.name}
          onClick={() => setLanguage(l.code)}
        >
          {l.short}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
